import { render, staticRenderFns } from "./singleChoicePicker.vue?vue&type=template&id=5778aa84&scoped=true"
import script from "./singleChoicePicker.vue?vue&type=script&lang=ts"
export * from "./singleChoicePicker.vue?vue&type=script&lang=ts"
import style0 from "./singleChoicePicker.vue?vue&type=style&index=0&id=5778aa84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_c2c4f8d10a02e12364bd9a7337709f82/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5778aa84",
  null
  
)

export default component.exports